module.exports = __webpack_public_path__ + "img/logo-princ.272bd2e8.png";